import { AxiosResponse } from "axios";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest
} from "services/client/request";
import { NewVoucher, Rewards, Voucher } from "types/Voucher";

const apiVersion = "/api/v1/business";

export const getAllVouchersApi = async (
  accessToken: string,
  businessId: string
): Promise<Voucher[]> => {
  const response: AxiosResponse<Voucher[]> = await getRequest(
    `${apiVersion}/vouchers/${businessId}`,
    accessToken
  );
  const vouchers: Voucher[] = response.data ? response.data : [];
  return vouchers;
};

export const createVoucherApi = async (
  request: NewVoucher,
  accessToken: string,
  businessId: string
): Promise<void> => {
  await postRequest(
    `${apiVersion}/vouchers/${businessId}`,
    accessToken,
    request
  );
};
export const updateVoucherApi = async (
  request: NewVoucher,
  accessToken: string,
  voucherId: string
): Promise<void> => {
  await patchRequest(
    `${apiVersion}/vouchers/${voucherId}`,
    accessToken,
    request
  );
};

export const deleteVoucherApi = async (
  id: number,
  accessToken: string
): Promise<void> => {
  await deleteRequest(`${apiVersion}/vouchers/${id}`, accessToken);
};

export const getAllRewardsApi = async (
  accessToken: string,
  businessId: string,
  page?: number
): Promise<Rewards> => {
  const response: AxiosResponse<Rewards> = await getRequest(
    `${apiVersion}/${businessId}/rewards?page=${page}`,
    accessToken
  );
  const vouchers: Rewards = response.data ? response.data : ({} as Rewards);
  return vouchers;
};
